import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
  AppBar,
  Box,
  Toolbar,
  Button,
  Typography,
  Menu,
  MenuItem,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemButton,
} from '@mui/material';
import PropTypes from 'prop-types';
import MenuIcon from '@mui/icons-material/Menu';
import LanguageIcon from '@mui/icons-material/Language';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Logo from '../../../assets/images/logos/logo.png';
import Logo1 from '../../../assets/images/logos/logo1.png';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import firebase from '../../../firebase';
import { updateProfile, updateRole } from '../../../redux/profile/action';

const LogoIcon = () => {
  return (
    <Link underline="none" to="/">
      <img src={Logo} style={{ height: '50px' }} alt="LOGO" />
    </Link>
  );
};

const Header = ({ sx }) => {
  const { t, i18n } = useTranslation();
  const [language, setLanguage] = useState('en');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [ctuAnchorEl, setCtuAnchorEl] = useState(null);
  const navigate = useNavigate();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const profileReducer = useSelector((state) => state.ProfileReducer);
  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCtuClick = (event) => {
    setCtuAnchorEl(event.currentTarget);
  };

  const handleCtuClose = () => {
    setCtuAnchorEl(null);
  };

  const handleLogout = () => {
    // Clear Redux state
    dispatch(updateRole({ info: {} }));
    dispatch(updateProfile({ logged_in: false, info: {}, token: '' }));

    // Clear localStorage auth state
    localStorage.removeItem('auth_state');
    localStorage.removeItem('api_tokens');

    // Firebase logout (for backward compatibility)
    // firebase.auth().signOut();

    // Navigate to login page
    navigate('/auth/login');
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const languages = [
    { code: 'en', label: 'English' },
    { code: 'hi', label: 'हिन्दी' },
  ];

  const menuItems = (
    <>
      <Link to="/" style={{ textDecoration: 'none' }}>
        <Typography color="textSecondary" variant="h5" fontWeight="500" sx={{ ml: 1, my: 2 }}>
          {t('home')}
        </Typography>
      </Link>
      <Link to="/campaign-dashboard" style={{ textDecoration: 'none' }}>
        <Typography color="textSecondary" variant="h5" fontWeight="500" sx={{ ml: 1, my: 2 }}>
          {t('campaign_dashboard')}
        </Typography>
      </Link>
      <Link to="/newreports" style={{ textDecoration: 'none' }}>
        <Typography color="textSecondary" variant="h5" fontWeight="500" sx={{ ml: 1, my: 2 }}>
          {t('reports')}
        </Typography>
      </Link>
      {profileReducer?.logged_in && (
        <Link to="/add-event" style={{ textDecoration: 'none' }}>
          <Typography color="textSecondary" variant="h5" fontWeight="500" sx={{ ml: 1, my: 2 }}>
            {t('dashboard')}
          </Typography>
        </Link>
      )}
      <Link to="/citizen" style={{ textDecoration: 'none' }}>
        <Typography color="textSecondary" variant="h5" fontWeight="500" sx={{ ml: 1, my: 2 }}>
          {t('Citizen Corner')}
        </Typography>
      </Link>
      {/* <Link to="/public-media" style={{ textDecoration: 'none' }}>
        <Typography color="textSecondary" variant="h5" fontWeight="500">
          Media
        </Typography>
      </Link> */}
      <Link to="/theme5-map" style={{ textDecoration: 'none' }}>
        <Typography color="textSecondary" variant="h5" fontWeight="500">
          Dumpsite Remediation
        </Typography>
      </Link>
      <Link to="/daily-bulletin" style={{ textDecoration: 'none' }}>
        <Typography color="textSecondary" variant="h5" fontWeight="500">
          Daily Bulletin
        </Typography>
      </Link>
      {/* Adopt CTU and CTU Guidelines are commented out below, leaving Identify
          CTU as the only entry -- and that one needs a login. So the whole CTU
          item is gated here rather than the entry alone, otherwise a logged-out
          visitor gets a CTU menu that opens empty.
          Mirrored in the mobile drawer copy further down. */}
      {profileReducer?.logged_in && (
        <Box sx={{ position: 'relative', display: 'inline-block' }}>
          <Typography
            color="textSecondary"
            variant="h5"
            fontWeight="500"
            sx={{
              ml: 1,
              my: 2,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              '&:hover': {
                color: 'primary.main',
              },
            }}
            onClick={handleCtuClick}
          >
            CTU
            <KeyboardArrowDownIcon sx={{ ml: 0.5 }} />
          </Typography>
          <Menu
            anchorEl={ctuAnchorEl}
            open={Boolean(ctuAnchorEl)}
            onClose={handleCtuClose}
            MenuListProps={{
              sx: { py: 0 },
            }}
          >
            {/* <MenuItem component={Link} to="/ctu-map" onClick={handleCtuClose} sx={{ py: 1.5, px: 2 }}>
              <Typography variant="body1">{t('adopt_ctu')}</Typography>
            </MenuItem> */}
            <MenuItem
              component={Link}
              to="/add-event?identify_ctu=true"
              onClick={handleCtuClose}
              sx={{ py: 1.5, px: 2 }}
            >
              <Typography variant="body1">{t('identify_ctu')}</Typography>
            </MenuItem>
            {/* <MenuItem
              component={Link}
              to="/ctu-guidelines"
              onClick={handleCtuClose}
              sx={{ py: 1.5, px: 2 }}
            >
              <Typography variant="body1">CTU Guidelines</Typography>
            </MenuItem> */}
          </Menu>
        </Box>
      )}
      {/* <a href="/rrr-map" style={{ textDecoration: 'none' }}>
        <Typography color="textSecondary" variant="h5" fontWeight="500" sx={{ ml: 1, my: 2 }}>
          RRR Centers
        </Typography>
      </a> */}

      {/* <a href="theme-1" style={{ textDecoration: 'none' }}>
        <Typography
          color="textSecondary"
          variant="h5"
          fontWeight="500"
          sx={{ ml: 1, my: 2 }}
        >
          {t('theme1')}
        </Typography>
      </a> */}

      {/* {profileReducer?.logged_in && (
        <Link to="/add-event?identify_ctu=true" style={{ textDecoration: 'none' }}>
          <Typography color="textSecondary" variant="h5" fontWeight="500" sx={{ ml: 1, my: 2 }}>
            {t('identify_ctu')}
          </Typography>
        </Link>
      )} */}
      {/* <Link to="/partners" style={{ textDecoration: 'none' }}>
        <Typography color="textSecondary" variant="h5" fontWeight="500" sx={{ ml: 1, my: 2 }}>
          {t('partners')}
        </Typography>
      </Link> */}
      {/* {!profileReducer?.logged_in && (
        <Link to="/partner-signup" style={{ textDecoration: 'none' }}>
          <Typography
            color="textSecondary"
            variant="h5"
            fontWeight="500"
            sx={{ ml: 1, my: 2 }}
          >
            {t('partner_signup')}
          </Typography>
        </Link>
      )} */}
      <Link to="/downloads" style={{ textDecoration: 'none' }}>
        <Typography color="textSecondary" variant="h5" fontWeight="500" sx={{ ml: 1, my: 2 }}>
          {t('downloads')}
        </Typography>
      </Link>
      {/* <Link to="/sop" style={{ textDecoration: 'none' }}>
        <Typography
          color="textSecondary"
          variant="h5"
          fontWeight="500"
          sx={{ ml: 1, my: 2 }}
        >
          {t('sop')}
        </Typography>
      </Link> */}
      {/* <Link to="/training-schedule" style={{ textDecoration: 'none' }}>
        <Typography
          color="textSecondary"
          variant="h5"
          fontWeight="500"
          sx={{ ml: 1, my: 2 }}
        >
          {t('training')}
        </Typography>
      </Link> */}
      {/* <div className="lang_div">
        <IconButton onClick={handleClick}>
          <LanguageIcon />
        </IconButton>
        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
          {languages.map((lang) => (
            <MenuItem
              key={lang.code}
              onClick={() => {
                changeLanguage(lang.code);
                handleClose();
              }}
            >
              {lang.label}
            </MenuItem>
          ))}
        </Menu>
      </div> */}
      {!profileReducer?.logged_in ? (
        <Link to="/auth/login" style={{ textDecoration: 'none' }}>
          <Button
            variant="contained"
            color="primary"
            sx={{
              mr: 2,
              my: 2,
              borderRadius: 10,
              width: '120px',
              backgroundColor: '#3939A0',
              border: '2px solid red',
              borderColor: '#8672FF',
            }}
          >
            {t('login')}
          </Button>
        </Link>
      ) : (
        <Button variant="contained" color="primary" sx={{ mr: 2, my: 2 }} onClick={handleLogout}>
          Logout
        </Button>
      )}
    </>
  );

  return (
    <>
      <AppBar
        sx={sx}
        elevation={0}
        style={{
          boxShadow: '0px 4px 33.8px 0px #00000033',
          backgroundColor: 'white',
          zIndex: 11,
        }}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={toggleSidebar}
            sx={{ mr: 2, display: { xs: 'block', md: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <LogoIcon />
          <img src={Logo1} style={{ height: '60px' }} alt="LOGO" />
          <Box flexGrow={1} />
          <Box
            sx={{
              display: { xs: 'none', md: 'flex', alignItems: 'center' },
              justifyContent: 'space-between',
              width: '80%',
            }}
          >
            {menuItems}
          </Box>
        </Toolbar>
      </AppBar>
      <Drawer anchor="left" open={sidebarOpen} onClose={toggleSidebar}>
        <Box
          sx={{ width: 250, m: 2 }}
          role="presentation"
          onClick={toggleSidebar}
          onKeyDown={toggleSidebar}
        >
          <List>
            {/* Render each menu item inside a ListItem for consistent spacing */}
            <ListItem>
              <Link to="/" style={{ textDecoration: 'none', width: '100%' }}>
                <ListItemText
                  primary={t('home')}
                  primaryTypographyProps={{
                    color: 'textSecondary',
                    variant: 'h6',
                    fontWeight: 500,
                  }}
                />
              </Link>
            </ListItem>
            <ListItem>
              <Link to="/campaign-dashboard" style={{ textDecoration: 'none', width: '100%' }}>
                <ListItemText
                  primary={t('campaign_dashboard')}
                  primaryTypographyProps={{
                    color: 'textSecondary',
                    variant: 'h6',
                    fontWeight: 500,
                  }}
                />
              </Link>
            </ListItem>
            <ListItem>
              <Link to="/newreports" style={{ textDecoration: 'none', width: '100%' }}>
                <ListItemText
                  primary={t('reports')}
                  primaryTypographyProps={{
                    color: 'textSecondary',
                    variant: 'h6',
                    fontWeight: 500,
                  }}
                />
              </Link>
            </ListItem>
            {profileReducer?.logged_in && (
              <ListItem>
                <Link to="/add-event" style={{ textDecoration: 'none', width: '100%' }}>
                  <ListItemText
                    primary={t('dashboard')}
                    primaryTypographyProps={{
                      color: 'textSecondary',
                      variant: 'h6',
                      fontWeight: 500,
                    }}
                  />
                </Link>
              </ListItem>
            )}
            <ListItem>
              <Link to="/citizen" style={{ textDecoration: 'none', width: '100%' }}>
                <ListItemText
                  primary={t('Citizen Corner')}
                  primaryTypographyProps={{
                    color: 'textSecondary',
                    variant: 'h6',
                    fontWeight: 500,
                  }}
                />
              </Link>
            </ListItem>
            {/* <ListItem>
              <Link to="/public-media" style={{ textDecoration: 'none', width: '100%' }}>
                <ListItemText
                  primary="Media"
                  primaryTypographyProps={{
                    color: 'textSecondary',
                    variant: 'h6',
                    fontWeight: 500,
                  }}
                />
              </Link>
            </ListItem> */}
            <ListItem>
              <Link to="/theme5-map" style={{ textDecoration: 'none', width: '100%' }}>
                <ListItemText
                  primary="Dumpsite Remediation"
                  primaryTypographyProps={{
                    color: 'textSecondary',
                    variant: 'h6',
                    fontWeight: 500,
                  }}
                />
              </Link>
            </ListItem>
            <ListItem>
              <Link to="/daily-bulletin" style={{ textDecoration: 'none', width: '100%' }}>
                <ListItemText
                  primary="Daily Bulletin"
                  primaryTypographyProps={{
                    color: 'textSecondary',
                    variant: 'h6',
                    fontWeight: 500,
                  }}
                />
              </Link>
            </ListItem>
            {/* Mobile drawer copy of the CTU menu. Keep in step with the desktop
                one above, including the login gate. */}
            {profileReducer?.logged_in && (
              <Box sx={{ position: 'relative', display: 'inline-block' }}>
                <ListItemButton onClick={handleCtuClick}>
                  <ListItemText
                    primary="CTU"
                    primaryTypographyProps={{
                      color: 'textSecondary',
                      variant: 'h6',
                      fontWeight: 500,
                    }}
                  />
                  <KeyboardArrowDownIcon sx={{ ml: 0.5 }} />
                </ListItemButton>
                <Menu
                  anchorEl={ctuAnchorEl}
                  open={Boolean(ctuAnchorEl)}
                  onClose={handleCtuClose}
                  MenuListProps={{
                    sx: { py: 0 },
                  }}
                >
                  {/* <MenuItem
                    component={Link}
                    to="/ctu-map"
                    onClick={handleCtuClose}
                    sx={{ py: 1.5, px: 2 }}
                  >
                    <Typography variant="body1">{t('adopt_ctu')}</Typography>
                  </MenuItem> */}
                  <MenuItem
                    component={Link}
                    to="/add-event?identify_ctu=true"
                    onClick={handleCtuClose}
                    sx={{ py: 1.5, px: 2 }}
                  >
                    <Typography variant="body1">{t('identify_ctu')}</Typography>
                  </MenuItem>
                  {/* <MenuItem
                    component={Link}
                    to="/ctu-guidelines"
                    onClick={handleCtuClose}
                    sx={{ py: 1.5, px: 2 }}
                  >
                    <Typography variant="body1">CTU Guidelines</Typography>
                  </MenuItem> */}
                </Menu>
              </Box>
            )}
            {/* <a href="/rrr-map" style={{ textDecoration: 'none' }}>
        <Typography color="textSecondary" variant="h5" fontWeight="500" sx={{ ml: 1, my: 2 }}>
          RRR Centers
        </Typography>
      </a> */}

            {/* <a href="theme-1" style={{ textDecoration: 'none' }}>
        <Typography
          color="textSecondary"
          variant="h5"
          fontWeight="500"
          sx={{ ml: 1, my: 2 }}
        >
          {t('theme1')}
        </Typography>
      </a> */}

            {/* {profileReducer?.logged_in && (
        <Link to="/add-event?identify_ctu=true" style={{ textDecoration: 'none' }}>
          <Typography color="textSecondary" variant="h5" fontWeight="500" sx={{ ml: 1, my: 2 }}>
            {t('identify_ctu')}
          </Typography>
        </Link>
      )} */}
            {/* <ListItem>
              <Link to="/partners" style={{ textDecoration: 'none', width: '100%' }}>
                <ListItemText
                  primary={t('partners')}
                  primaryTypographyProps={{
                    color: 'textSecondary',
                    variant: 'h6',
                    fontWeight: 500,
                  }}
                />
              </Link>
            </ListItem> */}
            <ListItem>
              <Link to="/downloads" style={{ textDecoration: 'none', width: '100%' }}>
                <ListItemText
                  primary={t('downloads')}
                  primaryTypographyProps={{
                    color: 'textSecondary',
                    variant: 'h6',
                    fontWeight: 500,
                  }}
                />
              </Link>
            </ListItem>
            {!profileReducer?.logged_in ? (
              <ListItem>
                <Link to="/auth/login" style={{ textDecoration: 'none', width: '100%' }}>
                  <Button
                    variant="contained"
                    color="primary"
                    sx={{
                      borderRadius: 10,
                      width: '100%',
                      backgroundColor: '#3939A0',
                      border: '2px solid red',
                      borderColor: '#8672FF',
                      mt: 1,
                    }}
                  >
                    {t('login')}
                  </Button>
                </Link>
              </ListItem>
            ) : (
              <ListItem>
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ width: '100%', mt: 1 }}
                  onClick={handleLogout}
                >
                  Logout
                </Button>
              </ListItem>
            )}
          </List>
        </Box>
      </Drawer>
    </>
  );
};

Header.propTypes = {
  sx: PropTypes.object,
};

export default Header;
